import {
  getCreatedAfterForCurrentWindow,
  getStartOfToday,
  getStartOfYesterday,
} from '../utils/shipmentUtils';

export const selectShipstationCurrentPageItems = (state) => {
  const { currentPage, pages } = state.shipstationShipment.list;
  return pages[currentPage] || [];
};

export const selectShipstationEffectiveFilter = (state) => {
  const { activeCategory, activeSubcategory, activeFacility, list } = state.shipstationShipment;
  const filter = { ...list.filter };

  // Category + subcategory determines status and optional date filter
  if (activeCategory === 'awaitingShipment') {
    filter.status = ['ORDER_CREATED'];
    if (activeSubcategory === 'recent') {
      filter.createdAfter = getCreatedAfterForCurrentWindow();
    }
  } else if (activeCategory === 'shipped') {
    if (activeSubcategory === 'voided') {
      filter.isVoided = true;
    } else {
      filter.status = ['ORDER_SHIPPED'];
      if (activeSubcategory === 'all') {
        // No date filter — all shipped shipments
      } else if (activeSubcategory === 'today') {
        filter.createdAfter = getStartOfToday();
      } else if (activeSubcategory === 'yesterday') {
        filter.createdAfter = getStartOfYesterday();
        filter.createdBefore = getStartOfToday();
      } else if (activeSubcategory === 'recent') {
        filter.createdAfter = getCreatedAfterForCurrentWindow();
      }
    }
  }

  if (activeFacility !== 'all') {
    filter.fulfillingPharmacyIds = [activeFacility];
  }

  return filter;
};
